// Catalog card = 1 product × 1 color. Matches MONTREAUX behavior.
// Operates on the new schema: main_image_url + color_ids[] + images[].

import type { ProductCard, ProductImage } from "@/shared/lib/db-schema";

export interface ExpandedCard {
  product: ProductCard;
  colorId: string;
  colorName: string;
  hexCode: string;
  image: string;
}

interface ExpandInput {
  product: ProductCard;
  images: ReadonlyArray<ProductImage>;
  colorMeta?: ReadonlyMap<string, { name: string; hex_code: string }>;
}

export function expandByColor({ product, images, colorMeta }: ExpandInput): ReadonlyArray<ExpandedCard> {
  const colors = product.color_ids;
  if (colors.length === 0) {
    const main = images.find((i) => i.is_main) ?? images[0];
    return [
      {
        product,
        colorId: "00000000-0000-0000-0000-000000000000",
        colorName: "",
        hexCode: "",
        image: main?.url ?? product.main_image_url,
      },
    ];
  }

  return colors.map((colorId) => {
    const imgs = images.filter((i) => i.color_id === colorId);
    const main = imgs.find((i) => i.is_main) ?? imgs[0] ?? images.find((i) => i.is_main) ?? images[0];
    const meta = colorMeta?.get(colorId);
    return {
      product,
      colorId,
      colorName: meta?.name ?? "",
      hexCode: meta?.hex_code ?? "",
      image: main?.url ?? product.main_image_url,
    };
  });
}
